import Flickity from 'flickity';
import $ from '../core/Dom';

export default el => {
    let flkty;
    const dom = $(el);
    const next = dom.find('[data-next]');
    const prev = dom.find('[data-prev]');
    const items = dom.find('[data-items]');

    const checkStatus = () => {
        if (flkty) {
            prev.attr('disabled', flkty.prevButton.isEnabled ? null : 'disabled');
            next.attr('disabled', flkty.nextButton.isEnabled ? null : 'disabled');
        }
    };

    const init = () => {
        items.removeClass('overflow-auto');
        flkty = new Flickity(items.get(0), {
            contain: true,
            dragThreshold: 10,
            cellAlign: 'left',
            cellSelector: '[data-item]',
            prevNextButtons: true,
            pageDots: false,
            wrapAround: false,
        });

        flkty.on('select', checkStatus);

        flkty.on('dragStart', () => {
            document.ontouchmove = e => e.preventDefault();
        });

        flkty.on('dragEnd', () => {
            document.ontouchmove = () => true;
        });

        next.on('click', () => {
            flkty.next();
        });

        prev.on('click', () => {
            flkty.previous();
        });
    };

    const destroy = () => {
        if (flkty) {
            next.off('click');
            prev.off('click');
            flkty.destroy();
            flkty = null;
        }
    };

    return {
        init,
        destroy
    };
};
